import React, { forwardRef } from 'react';
import { useLocation } from 'react-router-dom';

function withLocation(Component) {
  const WrappedComponent = forwardRef((props, ref) => {
    const location = useLocation();

    return (
      <Component
        {...props}
        location={location}
        ref={ref}
      />
    );
  });

  WrappedComponent.displayName = `withLocation(${Component.displayName || Component.name})`;
  return WrappedComponent;
}

export default withLocation;
